import { ErrorBoundary } from "@components/ErrorBoundary";
import { ToastHost } from "@components/ToastHost";
import { darkTheme } from "@features/theme";
import { queryClient } from "@lib/queryClient";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          {children}
          <ToastHost />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
